module.exports = __webpack_public_path__ + "img/temp2.c51e5b13.jpeg";